import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTattooFontGeneratorConfig } from '@/data/landingConfig/landingTattooFontGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TattooFontGenerator } from './schemaObject';

interface Props {}
const TattooFontGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TattooFontGenerator} />
			<LandingTemplate
				data={landingTattooFontGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTattooGenerator()}
			/>
		</>
	);
};

export default TattooFontGenerator;
